import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'

export const PlaybackSpeedOptionCell = styled.div<{
  $isSelected: boolean
}>`
  flex-shrink: 0;
  padding: 5px;
  width: 100%;

  border-radius: 4px;
  cursor: pointer;

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      background-color: ${COLORS.primaryLight};
      border: 1px solid ${COLORS.primaryDark};
    `}

  &:hover {
    background-color: ${COLORS.primaryLight};
  }

  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 64px;
    height: 44px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 1px solid ${COLORS.borderColor};

    &:hover {
      background-color: initial;
    }
  }
`
